export const VAUTO_TRIFORCE_REQUEST = 'VAUTO_TRIFORCE_REQUEST';
export const VAUTO_TRIFORCE_SUCCESS = 'VAUTO_TRIFORCE_SUCCESS';
export const VAUTO_TRIFORCE_FAILURE = 'VAUTO_TRIFORCE_FAILURE';
